import { createSelector } from 'reselect';

const selectOpenNetworkRegistrations = (state: any) => state.openNetworkRegistrations;


export const selectOpenNetworkRegistrationsCurrentItem = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.current);

export const selectOpenNetworkRegistrationsListItems = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectOpenNetworkRegistrationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpenNetworkRegistrationsQueryItems = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.query);

export const selectOpenNetworkRegistrationsCreatedItem = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.create);

export const selectOpenNetworkRegistrationsUpdatedItem = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.update);

export const selectOpenNetworkRegistrationsReadItem = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.read);

export const selectOpenNetworkRegistrationsDeletedItem = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.delete);

export const selectOpenNetworkRegistrationsSearchedItems = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.search);

export const selectOpenNetworkRegistrationsTriggerItem = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.trigger);


export const selectOpenNetworkRegistrationsItemsCount = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.count);

export const selectOpenNetworkRegistrationsItemsFilter = createSelector([selectOpenNetworkRegistrations], (openNetworkRegistrations) => openNetworkRegistrations.filter);